const ListRole = () => import('./ListRole.vue')
const EditRole = () => import('./EditRole.vue')
const NewRole = () => import('./NewRole.vue')
const TheContainer = () => import('@/containers/TheContainer')
const RouterView = { render: h => h('router-view') }

export default [
    {
        path: '/roles',
        name: 'roles',
        component: TheContainer,
        meta: {
            breadcrumb: {
                to: { name: 'roles.list' },
                text: 'Roles'
            }
        },
        children: [
            {
                path: 'list',
                name: 'roles.list',
                component: ListRole,
                meta: {
                    label: 'List Roles',
                },
            },
            {
                path: 'new',
                name: 'roles.new',
                component: NewRole,
                meta: {
                    label: 'Create new Role',
                    breadcrumb: {
                        text: 'Create New'
                    }
                },
            },
            {
                path: ':id',
                component: RouterView,
                meta: {
                    breadcrumb: {
                        text: (context) => {
                            const role = context.store.getters['roles/role']
                            if (!role || role.id !== parseInt(context.route.params.id)) {
                                context.store.dispatch('roles/fetchRole', context.route.params.id)
                                    .catch(err => console.error('Failed to load role for breadcrumb:', err))
                                return `Role #${context.route.params.id}`
                            }
                            return role.name || `Role #${context.route.params.id}`
                        },
                        to: (context) => ({
                            name: 'roles.edit',
                            params: { id: context.route.params.id }
                        })
                    }
                },
                children: [
                    {
                        path: '',
                        name: 'roles.edit',
                        component: EditRole,
                        meta: {
                            label: 'Edit Role',
                        },
                    }
                ]
            },
        ]
    }
]